import React from 'react';

import { AtlassianRelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

import { TeamButtonComponent } from '../team-button-component';

type ConfluenceTeamButtonProps = {
	containerId: string;
	numberOfTeams?: number;
	orgId?: string;
};

/** Applications using relay should have a single instance of the RelayEnvronmentProvider (see: https://relay.dev/docs/api-reference/relay-environment-provider/).
 * Resultantly, this component should be replaced by ./team-button-component once #cc-fe-performance team
 * enables relay support natively in Confluence. If you see this comment after Jan 1st 2026 please
 * reach out to them to see if there is a globally available relay environment available in Confluence.
 *
 */
export const ConfluenceTeamButton = ({
	numberOfTeams,
	containerId,
	orgId,
}: ConfluenceTeamButtonProps): React.JSX.Element => {
	return (
		<AtlassianRelayEnvironmentProvider>
			<TeamButtonComponent
				orgId={orgId}
				containerId={containerId}
				numberOfTeams={numberOfTeams}
				useButtonAriaLabel={false}
			/>
		</AtlassianRelayEnvironmentProvider>
	);
};
